import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';
import { Pixall, Google } from '../../analytics/index.js';
import getInventoryOwnerById from '../../utilities/getInventoryOwnerById';
import { getPageId } from '../../transformers/pixall/DataLayerTransformer.js';
import { inventoryTransformer as googleInventoryTransformer } from '../../transformers/google/index.js';
import { valueEventCode } from '../../constants/index.js';
import partnerResourceHelper from './partnerResourceHelper';
import mapPartnerTagToGA from './mapPartnerTagToGA';
const resourceClickHelper = function (_temp) {
  let {
    cmp,
    epn = ''
  } = _temp === void 0 ? {} : _temp;
  return (_ref, option) => {
    let {
      data,
      event,
      dataLayer,
      state
    } = _ref;
    const {
      inventoryId,
      par,
      pixallData: customPixallData = {}
    } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const currentPageName = _get(state, 'currentPageName', 'vdp');
    const isKBB = state?.brand === 'kbb';
    const pageId = getPageId(dataLayer);
    const isCapitalOne = epn === 'CapitalOne';
    let pixallData = Object.keys(customPixallData).length > 0 ? {
      ...customPixallData,
      label: cmp,
      eventSource: 'vehicle',
      eventType: 'click'
    } : null;
    const payload = {
      cmp,
      epn,
      par
    };

    // vendor (vn) should be lowercase
    const vendor = epn?.toLowerCase();
    let googleData = {};
    const additionalResources = _get(inventory, 'resources.additionalResources', []);
    const partnerResource = additionalResources.find(resource => resource.cmp === cmp);
    switch (cmp) {
      case 'get_loan_txt':
        {
          // GA eventResult and Pixall label take the same value
          const eventResult = mapPartnerTagToGA({
            name: isCapitalOne ? 'capitalone' : 'carchex',
            heading: `additional-resources::${partnerResource?.title}`,
            subhead: partnerResource?.link?.label,
            cta: event.target?.parentNode?.nodeName === 'SPAN' ? '' : 'module'
          });
          googleData = {
            eventElement: 'partner',
            eventResult
          };
          const getEventSource = () => {
            if (isCapitalOne) {
              return 'application';
            }
            return isKBB ? 'application' : 'dealership';
          };
          let label = 'get_loan';
          if (isKBB) {
            label = event.target?.parentNode?.nodeName === 'SPAN' ? eventResult : `wart_check - ${pageId}`;
          }
          pixallData = {
            ...pixallData,
            applicationType: isCapitalOne ? 'loan' : undefined,
            eventSource: getEventSource(),
            eventType: 'click',
            inventory,
            label,
            vendor,
            cdl: {
              eventProperties: {
                event: {
                  valueEventCode: isCapitalOne ? valueEventCode.CAPITALONE : valueEventCode.CARCHEX
                }
              }
            }
          };
          break;
        }
      case 'ny_syc':
        {
          pixallData = {
            ...pixallData,
            applicationType: 'credit',
            eventSource: 'application',
            inventory,
            label: 'ec_pa_txt',
            vendor,
            cdl: {
              eventProperties: {
                event: {
                  valueEventCode: valueEventCode.EXPERIAN
                }
              }
            }
          };
          googleData = {
            eventElement: 'partner',
            eventResult: `credit-report::${epn}::${partnerResource?.link?.label.replace(/[^a-zA-Z ]/g, '').trim().replace(/ /g, '-').toLowerCase()}`,
            eventData: {
              vehicle: googleInventoryTransformer(inventory, {
                target: 'vehicle',
                dataLayer
              })
            }
          };
          break;
        }
      case 'ns_tim':
        {
          googleData = {
            eventElement: currentPageName,
            eventResult: `tile::${currentPageName}::${_kebabCase(partnerResource?.link?.label)}`
          };
          break;
        }
      case 'get_quote_txt':
        {
          pixallData = {
            ...pixallData,
            label: 'cta_insurance_root-insurance',
            vendor,
            eventSource: 'insurance',
            eventType: 'click',
            inventory,
            vehicleType: (inventory?.listingType || '').toUpperCase()
          };
          googleData = {
            eventElement: 'partner',
            eventResult: partnerResourceHelper(partnerResource)
          };
          break;
        }
      default:
    }
    if (pixallData) {
      // Duplicate name but we need a value with the exact name "pixallData" here
      pixallData.pixallData = {
        ...pixallData?.pixallData,
        clickTypeToListingType: true
      };
      Pixall.sendClickEvent(pixallData, dataLayer, option);
    }
    if (googleData.eventResult) {
      Google.sendClickEvent(googleData, option);
    }
    return payload;
  };
};
export default resourceClickHelper;